import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { selectCurrentSite } from '../../../features/site/site.selectors';
import { Store } from '@ngrx/store';


@Component({
    selector: 'advandced-action-start-dialog',
    templateUrl: './advandced-action-start.dialog.html',
    styleUrls: ['../dialog.scss'],
    standalone: false
})
export class AdvandcedActionStartDialog {
  readonly currentSite$ = this.store.select(selectCurrentSite);
  constructor(private store: Store, public dialogRef: MatDialogRef<AdvandcedActionStartDialog>) {}
}


